export default " <div [ngClass]=\"isMobile ? 'bg-image' : ''\"><div> \r\n<!--    <div class=\"bg-image\"><div>\r\n-->\r\n"